import React, { useState } from 'react';
import moment from 'moment';
import IconChevron from './IconChevron';
import IconClose from './IconClose';
import { DisplayStateEnum } from './DatePickerEnum';

const DatePickerHeader = ({
    id,
    workingDate,
    minDate,
    maxDate,
    displayState,
    onUpdateWorkingDate,
    onTitleClick,
    onReset
}) => {
    const [isHighlighted, setIsHighlighted] = useState(false);

    const headerStyle = {
        boxSizing: 'border-box',
        height: 38,
        width: 'auto',
        border: '1px solid #FD9A00',
        borderRadius: '5px 5px 0 0',
        backgroundColor: '#FAA800',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    };

    const titleStyle = {
        display: 'inline-block',
        height: 40,
        width: 'auto',
        color: '#000000',
        fontFamily: 'Roboto',
        fontSize: 18,
        fontWeight: 'bold',
        letterSpacing: 0,
        lineHeight: '40px',
        paddingTop: 1,
        textDecoration:
            isHighlighted && displayState < DisplayStateEnum.YEAR
                ? 'underLine'
                : 'none',
        cursor:
            isHighlighted && displayState < DisplayStateEnum.YEAR
                ? 'pointer'
                : 'default',
        userSelect: 'none',
        KhtmlUserSelect: 'none',
        MsUserSelect: 'none',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none'
    };

    const workingMonth = workingDate.month();
    const tempMin = moment(minDate);
    const tempMax = moment(maxDate);
    const lowerBoundaryMonth = tempMin.month();
    const upperBoundaryMonth = tempMax.month();
    const workingYear = workingDate.year();
    const lowerBoundaryYear = tempMin.year();
    const upperBoundaryYear = tempMax.year();

    const handlePrev = () => {
        if (onUpdateWorkingDate) {
            switch (displayState) {
                case DisplayStateEnum.DAY:
                    onUpdateWorkingDate(
                        moment(workingDate.subtract(1, 'month'))
                    );
                    break;
                case DisplayStateEnum.MONTH:
                    onUpdateWorkingDate(
                        moment(workingDate.subtract(1, 'year'))
                    );
                    break;
            }
        }
    };

    const handleNext = () => {
        if (onUpdateWorkingDate) {
            switch (displayState) {
                case DisplayStateEnum.DAY:
                    onUpdateWorkingDate(moment(workingDate.add(1, 'month')));
                    break;
                case DisplayStateEnum.MONTH:
                    onUpdateWorkingDate(moment(workingDate.add(1, 'year')));
                    break;
            }
        }
    };

    const canHidePrev = () => {
        switch (displayState) {
            case DisplayStateEnum.DAY:
                return (
                    minDate !== undefined &&
                    workingMonth <= lowerBoundaryMonth &&
                    workingYear <= lowerBoundaryYear
                );
            case DisplayStateEnum.MONTH:
                return (
                    minDate !== undefined && workingYear <= lowerBoundaryYear
                );
            case DisplayStateEnum.YEAR:
                return true;
        }
    };

    const canHideNext = () => {
        switch (displayState) {
            case DisplayStateEnum.DAY:
                return (
                    maxDate !== undefined &&
                    workingMonth >= upperBoundaryMonth &&
                    workingYear >= upperBoundaryYear
                );
            case DisplayStateEnum.MONTH:
                return (
                    maxDate !== undefined && workingYear >= upperBoundaryYear
                );
            case DisplayStateEnum.YEAR:
                return true;
        }
    };

    const prevIcon = canHidePrev() ? (
        <div
            id={`${id}PrevElement`}
            style={{
                height: '20px',
                width: '20px',
                float: 'left',
                display: 'inline',
                padding: '7px 5px 0px 10px'
            }}
        />
    ) : (
        <IconChevron
            id={`${id}PrevElement`}
            width={18}
            height={18}
            style={{
                float: 'left',
                display: 'inline',
                padding: '14px 14px 7px 14px',
                transform: 'rotate(90deg)',
                cursor: 'pointer'
            }}
            onClick={handlePrev}
        />
    );

    const nextIcon = canHideNext() ? (
        displayState === DisplayStateEnum.YEAR ? (
            <IconClose
                height={15}
                width={15}
                style={{ padding: 14, cursor: 'pointer' }}
                id={`${id}-reset`}
                onClick={onReset}
            />
        ) : (
            <div
                id={`${id}NextElement`}
                style={{
                    height: '20px',
                    width: '20px',
                    float: 'right',
                    display: 'inline',
                    padding: '7px 10px 0px 0px'
                }}
            />
        )
    ) : (
        <IconChevron
            id={`${id}NextElement`}
            width={18}
            height={18}
            style={{
                float: 'right',
                display: 'inline',
                padding: '14px 14px 7px 14px',
                transform: 'rotate(270deg)',
                cursor: 'pointer'
            }}
            onClick={handleNext}
        />
    );

    const setTitle = () => {
        switch (displayState) {
            case DisplayStateEnum.DAY:
                return workingDate.format('MMMM YYYY');
            case DisplayStateEnum.MONTH:
                return workingDate.format('YYYY');
            case DisplayStateEnum.YEAR: {
                const startYear = workingDate.year() - 4;
                const endYear = startYear + 15;

                return `${startYear} - ${endYear}`;
            }
        }
    };

    const handleTitleClick = () => {
        if (onTitleClick && displayState < DisplayStateEnum.YEAR) {
            onTitleClick(displayState + 1);
        }
    };

    return (
        <div id={`${id}Header`} style={{ ...headerStyle }}>
            {prevIcon}
            <div
                id={`${id}DPTitle`}
                style={{ ...titleStyle }}
                onMouseOver={() => setIsHighlighted(true)}
                onMouseLeave={() => setIsHighlighted(false)}
                onClick={handleTitleClick}
            >
                {setTitle()}
            </div>
            {nextIcon}
        </div>
    );
};

export default DatePickerHeader;
